export default {
  apiKey: "AIzaSyCk94olOu96lKgTpbgmpKUsTG2p_mBRB8I",
  authDomain: "maha6-125a9.firebaseapp.com",
  projectId: "maha6-125a9",
  storageBucket: "maha6-125a9.firebasestorage.app",
  messagingSenderId: "50093523622",
  appId: "1:50093523622:web:36130e54ff45441acd6a67",
  measurementId: "G-636VDNHYDN",
};
